import React, { useState, useMemo, useEffect } from "react";
import { Image, Mask, Swiper, Avatar, Rate } from "antd-mobile";

import Iconfont from "~/components/ui/Iconfont";
import { tracker } from "~/common/tracker";

import { getTrackerSaReportInfo } from "../../../sensor-config";

import { BigImgProps } from "./types";
import styles from "./style.scss";

function BigImg(props: BigImgProps): JSX.Element | null {
  const { visible, closeModal, dataSource, defaultIndex, defaultCommentId, clickImg } = props;
  const [folded, setFolded] = useState(true);
  const [current, setCurrent] = useState(0);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (visible) {
      const currentIndex = dataSource?.findIndex((item) => item.id === `${defaultCommentId}-${defaultIndex}`);
      setCurrent(currentIndex > -1 ? currentIndex : 0);
      setIsReady(true);
    } else {
      setIsReady(false);
    }
  }, [visible]);

  // 关闭弹窗
  const handleClose = (): void => {
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickBack" }),
    });
    closeModal?.();
  };

  // 切换图片
  const handleChangeIndex = (index: number): void => {
    setCurrent(index);
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "swipeImg" }),
    });
  };

  // 收起展开
  const handleFold = (): void => {
    if (folded) {
      // 收起
      tracker.click({
        sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickExpand" }),
      });
    } else {
      tracker.click({
        sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickCollapse" }),
      });
    }
    setFolded(!folded);
  };

  // 点击图片收起评价内容 这个交互好奇怪啊
  const handleClickImg = (): void => {
    folded || setFolded(true);
    clickImg?.();
  };

  const currentItem = useMemo(() => dataSource?.[current] || {}, [dataSource, current]);

  /**
   * 这里使用 isReady，是因为 Swiper 只能设置默认值
   * 在没有算好 current 之前，展示内容了 就会导致 Swiper 展示的图片有问题
   * **/
  if (!isReady) return null;

  return (
    <Mask opacity={1} className={styles.mask} visible={visible}>
      <div className={styles.header}>
        <Iconfont name="right" onClick={handleClose} className={styles.header_icon} />
        <span>
          {current + 1} / {dataSource.length}
        </span>
      </div>
      <Swiper indicator={(): null => null} defaultIndex={current} onIndexChange={handleChangeIndex}>
        {dataSource.map((item) => (
          <Swiper.Item key={item.id}>
            <Image
              onClick={handleClickImg}
              src={item.image}
              fit="contain"
              width="100vw"
              height="100vh"
              className={styles.img}
            />
          </Swiper.Item>
        ))}
      </Swiper>
      {currentItem && currentItem.content && (
        <div onClick={handleFold} className={styles.footer}>
          {folded || (
            <>
              <div className={styles.footer_info}>
                {currentItem.avatar && <Avatar src={currentItem.avatar} className={styles.footer_avatar} />}
                <span className={styles.footer_user}>{currentItem.nickName}</span>
                <Rate
                  allowHalf
                  character={<Iconfont name="score_yellow" />}
                  className={styles.footer_rate}
                  readOnly
                  value={currentItem.goodsGrade}
                />
              </div>
              <div className={styles.footer_content}>{currentItem.content}</div>
            </>
          )}

          <div className={styles.footer_fold}>
            {/* 这里的span 展开状态下 是为flex 占位用 */}
            <span className={styles.footer_summary}>{folded ? currentItem.content : ""}</span>
            <span className={styles.fold_operate}>
              <Iconfont className={styles.fold_icon} name={folded ? "collapse" : "expand"} />
            </span>
          </div>
        </div>
      )}
    </Mask>
  );
}

export default BigImg;
